import { ConfiguracionSeleccionada } from './components/ConfiguracionSeleccionada'
import { DatosUsuario } from './components/DatosUsuario'
import { OpcionMenu } from './components/OpcionMenu'
import { claveActual } from '../../redux/slices/perfil'
import { useSelector } from 'react-redux'
import { opcionesMenu, MenuOpcion } from './opcionesMenus'

export const AjustesPagina = () => {
  const opcion = useSelector(claveActual)
  return (
    <>
      <div>
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <div className='d-flex align-items-center flex-grow-1'>
            <h1 className='m-0'>Ajustes</h1>
          </div>
        </div>
      </div>
      <div className='mt-5 mx-0'>
        <div className='card pt-2 row' style={{ height: '78vh' }}>
          <div className='col-3 h-100'>
            <div className='d-flex flex-column-auto h-125px card-rounded'>
              <DatosUsuario />
            </div>
            <div className='separator my-2'></div>

            <div className='d-flex flex-column w-100 mt-8 py-2 px-2'>
              {opcionesMenu.map((op: MenuOpcion) => (
                <OpcionMenu
                  key={op.clave}
                  titulo={op.titulo}
                  clave={op.clave}
                  descripcion={op.descripcion}
                  icon={op.icon}
                />
              ))}
            </div>
          </div>
          <div className='col-9 h-100'>
            <ConfiguracionSeleccionada opcion={opcion} />
          </div>
        </div>
      </div>
    </>
  )
}

export default AjustesPagina
